import { COLUMNSINFO, data2 } from './partten';
export default {
  data() {
    return {
      COLUMNSINFO,
      data: data2
      // defColumns: [,]
    };
  },
  methods: {
    handleExport() {
      window.location.href = 'http://test.home.console.insurforce.cn/excel/' + this.$t('产险业务报表') + '.xlsx';
    }
  }
};